// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

export const FRAGMENT_ARTICULO_MONEDA = gql`
  fragment fields on ArticuloMoneda {
    monedaPrimaria {
      _id
      codigo
      descripcion
      sigla
      tipoCambio
      tipoCambioCompra
      activo
      usucre
      usumod
      createdAt
      updatedAt
    }
    monedaAdicional1 {
      _id
      codigo
      descripcion
      sigla
      tipoCambio
      tipoCambioCompra
      activo
      usucre
      usumod
      createdAt
      updatedAt
    }
    monedaAdicional2 {
      _id
      codigo
      descripcion
      sigla
      tipoCambio
      tipoCambioCompra
      activo
      usucre
      usumod
      createdAt
      updatedAt
    }
    monedaAdicional3 {
      _id
      codigo
      descripcion
      sigla
      tipoCambio
      tipoCambioCompra
      activo
      usucre
      usumod
      createdAt
      updatedAt
    }
  }
`
